import { Controller } from "../../Controller";
import { ListarTitulosCobrancaService} from "../../../Services/Cobranca/Titulos/TitulosServices";
import { ITitulos, ITitulosResponse } from "../../../Interfaces/Cobranca/Titulos/TitulosInterface";

export async function ListarTitulosCobrancaController(requestBody: ITitulos){
    return Controller(
        ListarTitulosCobrancaService<ITitulosResponse>(requestBody, false)
    );
}

export async function ListarTitulosCobrancaExportarExcelController(requestBody: ITitulos){
    return Controller(
        ListarTitulosCobrancaService<Blob>(requestBody, true)
    );
}

